import { PropsWithChildren, ReactElement, useMemo } from "react";
import styles from "./Table.module.css";
import { classNames } from "@/utils/classNames";
import { TableContext } from "./TableContext";

export interface TableProps {
  variant?:
    | "LARGE"
    | "IN_CARD"
    | "IN_CARD_LARGE"
    | "IN_CARD_DENSE"
    | "EDITABLE"
    | "EDITABLE_DENSE"
    | "COMPACT";
  hoverable?: boolean;
  withRowBorders?: boolean;
  withoutHeaders?: boolean;
  inline?: boolean;
  containerClassName?: string;
  className?: string;
}

export function Table({
  variant = "LARGE",
  hoverable,
  withRowBorders,
  withoutHeaders,
  children,
  inline,
  containerClassName,
  className,
}: PropsWithChildren<TableProps>): ReactElement {
  const context = useMemo(
    () => ({
      editable: variant === "EDITABLE" || variant === "EDITABLE_DENSE",
      compact: variant === "EDITABLE_DENSE" || variant === "IN_CARD_DENSE",
    }),
    [variant],
  );
  const element = (
    <TableContext.Provider value={context}>
      <table
        className={classNames(
          className,
          !inline && "w-full",
          styles.table,
          styles[variant],
          hoverable && styles.hoverable,
          withRowBorders && styles.withRowBorders,
          withoutHeaders && styles.withoutFirstRowBorder,
        )}
      >
        {children}
      </table>
    </TableContext.Provider>
  );
  return inline ? (
    element
  ) : (
    <div className={classNames(styles.container, containerClassName)}>{element}</div>
  );
}
